import { Controller } from "@hotwired/stimulus";

// Controller for an attachment.
export default class extends Controller {
  // Optimistically "remove" an attachment (i.e., hide it before the delete
  // action's `turbo_stream.remove` has run).
  remove() {
    this.element.classList.add("hidden");

    this.dispatch("removed");
  }
}
